import React from 'react';

const Footer = () => {
    return (
        <div>
            <footer className="footer footer-center p-4 bg-base-300 text-base-content">
                <div>
                    <p>Copyright © 2022 - All right reserved by Md Al Amin</p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;